"use client";
import React from "react";
import Context from "./CheckboxGroup.context.js";
const CheckboxGroupControlled = (props) => {
    const { onChange, name, disabled, value, children, hasError } = props;
    const handleChange = (args) => {
        const { event, value: fieldValue, checked } = args;
        if (!fieldValue)
            return;
        let nextValue = [...value];
        if (checked) {
            nextValue.push(fieldValue);
        }
        else {
            nextValue = nextValue.filter((v) => v !== fieldValue);
        }
        if (onChange)
            onChange({ name, value: nextValue, event });
    };
    return (React.createElement(Context.Provider, { value: { onChange: handleChange, disabled, value, name, hasError } }, children));
};
export default CheckboxGroupControlled;
